Dropzone.autoDiscover = false;
jQuery(function($){

	//====================
	// Sample CSV
	//====================
	$('#download-sample-csv').on('click', function(e){
		e.preventDefault();

		if($('#sample-csv-questions').length > 0) {
			$('#sample-csv-questions').show();
		} else if($(this).closest('form').length > 0) {
			$(this).closest('form').submit();
		}
	});

	$('#sample-csv-questions .question-box-background').on('click', function(){
		$('#sample-csv-questions').hide();
	});

	$('#sample-csv-questions .question-box .close-box').on('click', function(){
		$('#sample-csv-questions').hide();
	});


	//====================
	// Dropzone
	//====================
	let dropzoneFieldTypes = [
		{
			className: 'file-upload',
			options: {
				className: 'file-upload',
				addRemoveLinks: true
			}
		},
		{
			className: 'csv-upload',
			options: {
				className: 'csv-upload',
				acceptedFiles: '.csv',
				uploadMultiple: false,
				maxFiles: 1,
				addRemoveLinks: true
			}
		}
	];

	$.each(dropzoneFieldTypes, function(index, type){
		setDropzoneField(type.className, type.options);
	});

	function setDropzoneField(className, additionalOptions) {
		if($('.dropzone.' + className).length > 0) {
			let dropzoneOptions = {
				url: '/wp-admin/admin-ajax.php',
				acceptedFiles: $('#accepted-filetypes').val(),
				timeout: 0,
				sending: function(file, response, formData) {
					this.removedAutomatically = 'false';
					formData.append('action', 'sc_field_editor_process_dropzone_file');
					formData.append('import_folder', $(file.previewElement).closest('form').find('input[name=import_folder]').val());
				},
				removedfile: function(file) {
					if(this.removedAutomatically == 'false') {
						let validationMessages = $(file.previewElement).closest('.field').find('.validation-messages');
						validationMessages.html('');
					}

					if(className == 'csv-upload') dropzoneVisibility(false, $(file.previewElement).closest('form'));

					if(file.previewElement != null && file.previewElement.parentNode != null) {
						file.previewElement.parentNode.removeChild(file.previewElement);
					}

					let parentDiv = $(file.previewElement).closest('.dropzone');
					updateDropzoneHiddenInputFilenames(parentDiv);

					return this._updateMaxFilesReachedClass();
				},
				success: function(file, response, formData) {
					var trimmedFilename = response.trim();
					setFilenameAfterDrop(file, trimmedFilename, formData);
					additionalDropzoneProcessing(file, trimmedFilename, formData, this);
				}
			}

			if(Object.keys(additionalOptions).length > 0) {
				$.each(additionalOptions, function(key, value){
					dropzoneOptions[key] = value;
				});
			}

			new Dropzone('.dropzone.' + className, dropzoneOptions);
		}
	}

	function additionalDropzoneProcessing(file, response, formData, drop) {
		if($(drop.previewsContainer).hasClass('csv-upload')) {
			validateCsvUpload(file, response, formData, drop);
		} else {
			$(file.previewElement).addClass('dz-success');
		}
	}

	function dropzoneVisibility(visible, form) {
		if(visible) {
			form.find('.field.file-upload').show();
			form.find('button.submit').removeClass('disabled').attr('disabled', false);
		} else {
			form.find('.field.file-upload').hide();
			form.find('button.submit').addClass('disabled').attr('disabled', true);
		}
	}

	function getProcessingSvg() {
		return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" \
		width="54px" height="54px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">\
		<path opacity="1" fill="#FFFFFF" d="M47.87,10.24V15c-18.26,0.97-32.89,15.6-33.86,33.86H9.25C10.24,27.98,26.99,11.23,47.87,10.24z">\
			<animateTransform attributeName="transform"\
		                  attributeType="XML"\
		                  type="rotate"\
		                  from="0 50 50"\
		                  to="360 50 50"\
		                  dur="2s"\
		                  repeatCount="indefinite"/>\
		</path>\
		<path opacity="1" fill="#FFFFFF" d="M80.69,52.75C79.73,68.29,67.3,80.72,51.76,81.68v-4.47c13.07-0.94,23.52-11.38,24.46-24.46H80.69z">\
			<animateTransform attributeName="transform"\
		                  attributeType="XML"\
		                  type="rotate"\
		                  from="0 50 50"\
		                  to="360 50 50"\
		                  dur="3s"\
		                  repeatCount="indefinite"/>\
		</path>\
		</svg>';
	}

	function updateDropzoneHiddenInputFilenames(parentDiv) {
		setTimeout(function(){
			let filenames = [];
			parentDiv.find('.dz-preview.dz-complete').each(function(){
				if(!$(this).hasClass('dz-error')) {
					filenames.push($(this).find('.dz-details .dz-filename > span').html());
				}
			});
			console.log(filenames);
			parentDiv.find('input.filenames').val(btoa(JSON.stringify(filenames)));
		}, 1000);
	}

	function setFilenameAfterDrop(file, filename, formData) {
		$(file.previewElement).find('.dz-success-mark').after('<div class="dz-processing-spinner">' + getProcessingSvg() + '</div>');
		$(file.previewElement).find('.dz-details .dz-filename > span').html(filename);

		let parentDiv = $(file.previewElement).closest('.dropzone');
		updateDropzoneHiddenInputFilenames(parentDiv);
	}

	function validateCsvUpload(file, filename, formData, drop) {
		let postType = $(file.previewElement).closest('form').find('input.post_type').val();
		let validationMessages = $(file.previewElement).closest('.field').find('.validation-messages');
		let uploadId = $(file.previewElement).closest('form').find('input[name=import_folder]').val();

		validationMessages.html('<h3>Validating file...</h3>');
		$.post('/wp-admin/admin-ajax.php', {action: 'sc_field_editor_validate_csv_upload', filename: filename, post_type: postType, import_folder: uploadId}, function(response){
			console.log(response);
			let responseJson = JSON.parse(response);
			validationMessages.html(responseJson.message.replace(/\\/g, ''));
			if(responseJson.type == 'error') {
				// $(file.previewElement).addClass('dz-error');
				drop.removedAutomatically = 'true';
				drop.removeFile(file);
				drop.removedAutomatically = 'false';
			} else {
				dropzoneVisibility(true, $(file.previewElement).closest('form'));
				$(file.previewElement).addClass('dz-success');
			}
		});
	}


	let onclickParent = '.sc-field-editor .field';

	//===============================
	// Expand Array Field Groups
	//===============================

	//Expand on click
	$(onclickParent).on('click', '.file-group .header', function(e){
		e.stopPropagation();
		$(this).closest('.file-group').toggleClass('expanded');
	});

	//Do not expand if order number is clicked
	$(onclickParent).on('click', '.file-group .header .remove', function(e){
		e.stopPropagation();
		var parentDiv = $(this).closest('.field.upload-file');
		var file = $(this).closest('.field.import-file');
		var fileHTML = file.prop('outerHTML');
		var extension = file.attr('extension');

		parentDiv.find('input.file-index-field').val('');
		file.before('<div class="placeholder">No file selected</div>').removeClass('associated').attr('draggable', true);

		$('#unassociated-' + extension).append(file);
	});

	$('.unassociated-files').on({
		dragstart: function(e) {
			//Adjust attributes to write to setData
			$(e.target).attr('draggable', false);
			$(e.target).addClass('associated');

			//Write to setData
			e.originalEvent.dataTransfer.setData('fileIndex', $(e.target).attr('file-index'));
			e.originalEvent.dataTransfer.setData('extension', $(e.target).attr('extension'));
			e.originalEvent.dataTransfer.setData('div', $(e.target).prop('outerHTML'));

			//Reset attributes
			$(e.target).attr('draggable', true);
			$(e.target).removeClass('associated');

			//Add .dragging for css
			$(e.target).addClass('dragging');
		},
		dragend: function(e) {
			console.log('dragend');
			$(e.target).removeClass('dragging');
		}
	}, '.field[draggable=true]');

	$('.upload-field').on({
		dragenter: function(e) {
			$(e.target).addClass('dropping');
		},
		dragleave: function(e) {
			$(e.target).removeClass('dropping');
		},
		dragover: function(e) {
			e.originalEvent.dataTransfer.dropEffect = 'copy';
			return false;        
		},
		drop: function(e) {
			console.log('placeholder drop');
			$(e.target).removeClass('dropping');

			var parentDiv = $(e.target).closest('.field.upload-file');
			var extension = e.originalEvent.dataTransfer.getData('extension');
			var allowedFiletypes = JSON.parse(atob(parentDiv.attr('allowed_filetypes')));

			if(inArray(extension, allowedFiletypes)) {
				var fileIndex = e.originalEvent.dataTransfer.getData('fileIndex');
				var div = e.originalEvent.dataTransfer.getData('div');

				parentDiv.find('input.file-index-field').val(fileIndex);
				$(e.target).after(div).remove();
				$('.sc-field-editor .unassociated-files [file-index="' + fileIndex + '"]').remove();
			} else {
				window.alert('Filetype "' + extension + '" not allowed for this field.  Please choose a file with one of the following extensions: ' + allowedFiletypes);
			}
		}
	}, '.placeholder');


	function showFileIndexes() {
		$('input.file-index-field').each(function(){
			console.log($(this).attr('name'), $(this).val());
		});
	}

	function inArray(needle, haystack) {
		var length = haystack.length;
		for(var i = 0; i < length; i++) {
			if(haystack[i] == needle) return true;
		}
		return false;
	}
});